<template>
	<div class="ss-content volunteer-home-content">
		<div class="ss-container">
			<div class="ss-container__left_small">
				<ul class="volunteer-types">
					<li class="volunteer-types__title">关于文化馆</li>
					<li v-for="(item, index) in typeList" :class="{active: typeIndex === index}" @click="changeType(item.value, index)" :key="index">{{item.label}}</li>
				</ul>
			</div>
			<div class="ss-container__right_big">
				<div class="ss-container__right_top" v-if="$route.name !== 'libraryTeamDetail'">{{title_}}</div>
				<div class="ss-container__right_bottom">
					<router-view />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				typeIndex: 0,
				typeList: [{
					exp: ['aboutSurvey'],
					value: 'aboutSurvey',
					label: '大兴文化馆概况'
				}, {
					exp: ['aboutIntro'],
					value: 'aboutIntro',
					label: '总分馆体系介绍'
				}, {
					exp: ['partyBuildingGarden', 'PartyBuildingGardenDetail'],
					value: 'partyBuildingGarden',
					label: '党建园地'
				}, {
					exp: ['libraryTeam', 'libraryTeamDetail'],
					value: 'libraryTeam',
					label: '馆办团队'
				}, {
					exp: ['libraryPublications'],
					value: 'libraryPublications',
					label: '馆办刊物'
				},
				//  {
				// 	exp: ['culturalCloudFront'],
				// 	value: 'culturalCloudFront',
				// 	label: '馆办云阵地'
				// },
				 {
					exp: ['contact'],
					value: 'contact',
					label: '联系方式'
				}, {
					exp: ['app'],
					value: 'app',
					label: '大兴数字文化馆'
				}]
			}
		},
		computed:{
			title_() {
				return this.typeList[this.typeIndex].label
			}
		},
		watch: {
			'$route.path': {
				handler: function(val, oldVal){
					let typeIndex = this.typeList.findIndex(o => o.exp.findIndex(o1 => o1 === this.$route.name) !== -1);
					this.typeIndex = typeIndex === -1 || typeIndex >= this.typeList.length ? 0 : typeIndex;
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			changeType(name, index) {
				this.$route.name !== name && this.$router.replace({
					name: name
				})
			}
		}
	}
</script>

<style lang="scss">
	@import '~@/views/volunteerHome/css/volunteer-home.scss';
	.volunteer-types{
		li{
			&::after{
				content: '';
				@include abs(null, 15px, 0, 15px);
				background-color: #DEDEDE;
				height: 1px;
			}
			&:last-child::after, &:first-child::after{
				display: none;
			}
		}
	}
</style>
